import React from 'react';
import { appVersion } from '../../config/AppVersion';

const Footer = () => {
  return (
    <footer 
      className="footer bg-success text-white fw-bold py-2 small w-100 shadow-sm"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1001,
      }}
    >
      <div className="container d-flex justify-content-between align-items-center small">
        <p className="mb-0 flex-grow-1 text-center">
          © {new Date().getFullYear()} - I & J Serviços de Consultoria em TI - Todos os direitos reservados.
        </p>
        <p className="mb-0 ms-3">{appVersion}</p>
      </div>
    </footer>
  );
};

export default Footer;